<template>
<div>
    <ContractorsAddressesListTable />
    <v-content>
        <v-btn fab bottom right color="pink" dark fixed @click="cardOpen()">
            <v-icon>add</v-icon>
        </v-btn>
    </v-content>
    <ContractorsAddressesNewCard />
</div>
</template>

<script>
import {
    HTTP
} from '../http-common'

import ContractorsAddressesNewCard from './ContractorsAddressesNewCard.vue'
import ContractorsAddressesListTable from './ContractorsAddressesListTable.vue'

export default {
    components: {
        ContractorsAddressesNewCard,
        ContractorsAddressesListTable
    },
    data: () => ({
        errorS: [],
        error: false,
        loading: false,
        items: []
    }),
    props: {},
    methods: {
        cardOpen() {
            this.$store.commit('openCloseContractorsAddresses', !this.$store.state.main.cardContractorsAddressesOpened);
        },

    }
}
</script>
